const systemBase = () => import('@/page/system/base.vue')
const systemCompany = () => import('@/page/system/company-add.vue')
const systemStaff = () => import('@/page/system/staff.vue')
const systemAccount = () => import('@/page/system/account.vue')
const systemDevice = () => import('@/page/system/device.vue')
const department = () => import('@/page/system/department.vue')
const idCard = () => import('@/page/system/id-card.vue')
const modifyPassword = () => import('@/page/system/modify-password.vue')
const recoRecord = () => import('@/page/system/reco-record.vue')
const systemVisitor = () => import('@/page/system/visitor.vue')
const systemVerupgrade = () => import('@/page/system/verupgrade.vue')
export default [
  {
    path: '/system/account',
    component: systemAccount,
    name: 'systemAccount'
  },
  {
    path: '/system/base',
    component: systemBase,
    name: 'systemBase'
  },
  {
    path: '/system/company',
    component: systemCompany,
    name: 'systemCompany'
  },
  {
    path: '/system/department',
    component: department,
    name: 'department'
  },
  {
    path: '/system/device',
    component: systemDevice,
    name: 'systemDevice'
  },
  {
    path: '/system/id-card',
    component: idCard,
    name: 'idCard'
  },
  {
    path: '/system/modify-password',
    component: modifyPassword,
    name: 'modify-password'
  },
  {
    path: '/faces/reco-record',
    component: recoRecord,
    name: 'reco-record'
  },
  {
    path: '/system/staff',
    component: systemStaff,
    name: 'systemStaff'
  },
  {
    path: '/system/visitor',
    component: systemVisitor,
    name: 'systemVisitor'
  },
  {
    path: '/system/verupgrade',
    component: systemVerupgrade,
    name: 'systemVerupgrade'
  },
]



// WEBPACK FOOTER //
// ./src/router/system.js